import { Notification } from '../design-system';
import { formatPrice } from '../currency';
import { useIsSleek } from '../theme';
import { BuybackCoins } from './BuybackCoins';

type Props = {
  /** Gross buyback amount credited to the balance. */
  amount: number;
};

const PRICE_DECIMALS = 2;

// Sleek's icon reads the same Design Constructor knob as the coins badge, so
// an operator can paste their own art (e.g. Betr's cash stack). Unset, it
// falls back to a green cash glyph. Inline style: the fallback is a data URI.
const SLEEK_ICON_STYLE = {
  backgroundImage:
    'var(--co-BuybackNotification-iconImage, url("data:image/svg+xml,%3Csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 24 24%27 fill=%27none%27 stroke=%27%2354E24F%27 stroke-width=%271.8%27 stroke-linecap=%27round%27 stroke-linejoin=%27round%27%3E%3Crect x=%272%27 y=%276%27 width=%2720%27 height=%2712%27 rx=%272%27/%3E%3Ccircle cx=%2712%27 cy=%2712%27 r=%272.5%27/%3E%3Cpath d=%27M6 10v4M18 10v4%27/%3E%3C/svg%3E"))',
} as const;

/**
 * The buyback toast's pill. Sleek (partner mockup) is a flat card that leads
 * with a 28px cash icon (the operator's `iconImage`, else a glyph) and the
 * amount in the accent green (partner feedback 2026-10-01 — sleek is Betr's;
 * "Fantasy" dropped from the wallet's name 2026-10-13); every other template
 * keeps the coins badge and its sentence.
 */
export function BuybackToastBody({ amount }: Props) {
  const isSleek = useIsSleek();
  const price = formatPrice(amount, PRICE_DECIMALS);

  if (!isSleek) {
    return (
      <Notification inspectName="BuybackNotification" icon={<BuybackCoins />}>
        {price} Buyback amount has been deposited into your wallet!
      </Notification>
    );
  }
  return (
    <Notification
      inspectName="BuybackNotification"
      variant="card"
      icon={
        <span
          aria-hidden
          className="block size-7 shrink-0 bg-contain bg-center bg-no-repeat [border-radius:var(--co-BuybackNotification-iconRadius,0px)]"
          style={SLEEK_ICON_STYLE}
        />
      }
    >
      <span className="text-[var(--co-Notification-accent,#54E24F)]">{price}</span> has been deposited into your wallet!
    </Notification>
  );
}
